import axios from 'axios';

export default {
  beforeMount() {
    const vm = this;
    if (!vm.$store.state.user.isAuthenticated) {
      axios
        .get('/api/identity')
        .then(function(resp) {
          if (resp.data) {
            let identity = resp.data;
            identity.isAuthenticated = true;
            vm.$store.commit('updateUser', identity);
          }
        })
        .catch(function(error) {
          vm.$store.commit('updateUser', { isAuthenticated: false });

          if (error.response.status === 401) {
            window.location.href = '/identity/account/login?ReturnUrl=%2F';
          } else if (error.response.status === 403) {
            window.location.href =
              '/identity/account/accessdenied?ReturnUrl=%2F';
          }
        });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    }
  },
  methods: {
    isInRole(role) {
      const user = this.$store.state.user;
      return (user.roles && user.roles.indexOf(role) > -1) || user.isAdmin;
    }
  }
};
